export const DisabledReasonCode = Object.freeze({
  APP_NOT_ACTIVE: 'APP_NOT_ACTIVE',
  MISMATCHED_SUBSCRIPTION_TYPE: 'MISMATCHED_SUBSCRIPTION_TYPE'
});
export const ValidateErrorCode = Object.freeze({
  INVALID_PROMO_CODE: 'INVALID_PROMO_CODE',
  PROMO_EXPIRED: 'PROMO_EXPIRED',
  MISSING_APPS: 'MISSING_APPS',
  INVALID_SUBSCRIPTION_TYPE: 'INVALID_SUBSCRIPTION_TYPE',
  EXHAUSTED_USES: 'EXHAUSTED_USES',
  PROMO_ACTIVE: 'PROMO_ACTIVE',
  PROMO_NOT_STARTED: 'PROMO_NOT_STARTED',
  PROMO_ENDED: 'PROMO_ENDED',
  USED_PROMO: 'USED_PROMO',
  INVALID_CLOUD_ID: 'INVALID_CLOUD_ID',
  INVALID_HOSTING_TYPE: 'INVALID_HOSTING_TYPE'
});
export const AppliedPromotionStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
});
export const ValidationResult = Object.freeze({
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS'
});
export const disableReasonCodeMap = {
  [DisabledReasonCode.MISMATCHED_SUBSCRIPTION_TYPE]: 'due to change in billing cycle',
  [DisabledReasonCode.APP_NOT_ACTIVE]: 'since one of the eligible app is uninstalled'
};